import React, {Component} from 'react';
import '../../style.css';
import {Button, Card, message, Space, DatePicker, PageHeader, Tag, Spin, Tooltip, Modal} from "antd";
import { fetchPost,fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';
import 'moment/locale/zh-cn';
import locale from 'antd/lib/locale/zh_CN';

class BuildProjectResolution extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            Year:"请选择年份",
            status:false,
            fileStream:'',
            fileStreamYear:'',
            flag:true,
            checkStatus:false,
            loading:false,
            loadingFirst:false,
            combine_visible:false,
        }
        this.fileInput=this.fileInput.bind(this);
        this.upload=this.upload.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }
    // componentDidMount() {
    //     let params = {
    //         companyId:this.state.companyId,
    //         fileName: '立项决议.pdf'
    //     }
    //     fetchPost(global.constants.checkFileProcess, params)
    //         .then(
    //             res => {
    //                 if(res.code === 200){
    //                     this.setState(()=>({
    //                         checkStatus:true,
    //                     }))
    //                 }
    //             })
    // }
    hideModal(){
        this.setState(()=>({
            combine_visible:false,
        }))
    }
    lookCombine(){
        let params = {
            companyId:this.state.companyId,
            fileName: '立项决议.pdf'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            loadingFirst:true,
                            combine_visible:true,
                        }))
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/立项决议.pdf',
                            fileName: '立项决议.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                loadingFirst:false,

                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info('该先上传往年立项决议').then()
                    }
                })

    }
    fileInput(){
        this.setState(()=>({
            fileStreamYear:'',
            fileField:document.querySelector("input[type='file']"),
            flag:false
        }))
    }
    upload(){
        if(this.state.Year === '请选择年份'){
            message.info('请先选择年份再上传').then()
        }else{
            this.setState(()=>({
                loading:true
            }))
            const formdata = new FormData();
            formdata.append('file', this.state.fileField.files[0]);
            formdata.append('companyId',this.state.companyId);
            formdata.append('projectId',0);
            formdata.append('productId',0);
            formdata.append('patentId',0);
            formdata.append('otherId',0);
            formdata.append('remark',this.state.Year+'年立项决议');
            if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
                alert("只允许上传pdf格式的文件")
                this.setState(()=>({
                    loading:false
                }))
            } else {
                fetch(global.constants.uploadFile, {
                    method: 'POST',
                    body: formdata,
                    mode: 'cors',
                    credentials: 'include',
                })
                    .then(res => res.json())
                    .then(
                        res => {
                            if (res.code === 200) {
                                let params = {
                                    companyId: this.state.companyId,
                                    projectId: 0,
                                    productId: 0,
                                    patentId: 0,
                                    otherId: 0,
                                    remark: this.state.Year+'年立项决议',
                                    url: '',
                                    fileName: ''
                                }
                                fetchPostFile(global.constants.previewFile, params)
                                    .then(
                                        res => {
                                            res.blob().then(
                                                blob => {
                                                    let blobUrl = window.URL.createObjectURL(blob);
                                                    this.setState(() => ({
                                                        fileStreamYear: blobUrl,
                                                        loading :false
                                                    }))
                                                })
                                        }
                                    )
                                //上传之后重新合并
                                let params1 = {
                                    companyId:this.state.companyId,
                                    remark:"立项决议"
                                }
                                fetchPost(global.constants.mergeReport, params1)
                                    .then(
                                        res => {
                                            if (res.code === 200) {
                                                message.success("上传并合并成功").then()
                                            }
                                            else{
                                                message.info("未查询到可合并的文件，请先上传往年的立项决议！").then()
                                            }
                                        }
                                    )
                                        }
                            }
                        )
            }
        }
    }
    YearChange=(value,dateString)=>{
        this.setState(()=>({
            Year:dateString,
            fileStreamYear:''
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:dateString + '年立项决议',
            url:'',
        }
        fetchPost(global.constants.checkFile, params)
            .then(
                res => {
                    if(res.code === 200) {
                        let params = {
                            companyId: this.state.companyId,
                            projectId: 0,
                            productId: 0,
                            patentId: 0,
                            otherId: 0,
                            remark: dateString + '年立项决议',
                            url: '',
                            fileName: ''
                        }
                        fetchPostFile(global.constants.previewFile, params)
                            .then(
                                res => {
                                    res.blob().then(
                                        blob => {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(() => ({
                                                fileStreamYear: blobUrl,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info('该年份未上传立项决议').then()
                    }
                })
    }
    delete(){
        if(this.state.Year === '请选择年份'){
            message.info('请先选择年份再操作').then()
        }else {
            let params = {
                companyId: this.state.companyId,
                projectId: 0,
                productId: 0,
                patentId: 0,
                otherId: 0,
                remark: this.state.Year+'年立项决议',
                url: '',
            }
            fetchPost(global.constants.deleteFile, params)
                .then(
                    res => {
                        if (res.code === 200) {
                            message.success("删除成功").then()
                            this.setState(() => ({
                                fileStreamYear:""
                            }))
                            //删除之后重新合并
                            let params1 = {
                                companyId:this.state.companyId,
                                remark:"立项决议"
                            }
                            fetchPost(global.constants.mergeReport, params1)
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            message.success("删除并重新合并成功").then()
                                        }
                                        else{
                                            message.info("未查询到可合并的文件，请先上传往年的立项决议！").then()
                                        }
                                    }
                                )
                        }
                        else{
                            message.info("该年份的立项决议未上传").then()
                        }
                    }
                )
        }
    }

    render() {
        return (
            <div>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="立项决议"
                        subTitle='只允许上传50M以内的pdf格式的文件'
                        // tags={
                        //     this.state.checkStatus === true?<Tag color="green" className="Tag_style">
                        //         已合并</Tag>:<Tag color="red" className="Tag_style">未合并</Tag>
                        // }
                        extra={[
                            <Tooltip title="查看已合并的立项决议">
                                <Button  onClick={this.lookCombine.bind(this)}>查看</Button>
                            </Tooltip>,
                            <DatePicker  locale={locale} format={'YYYY'}  onChange={this.YearChange.bind(this)} picker="year" />,

                            <input type="file" name='file' onChange={this.fileInput}/>,
                            <Button type="primary" onClick={this.upload} disabled={this.state.flag}>上传</Button>,
                            <Spin tip={"上传中..."} spinning={this.state.loading}/>,
                            <Button onClick={this.delete.bind(this)}>删除</Button>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <Space direction="vertical" className="content-style" >
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9',textAlign:'center'}} >
                        <div style = {{fontSize:30, paddingBottom:20}} >
                            {
                                (this.state.Year !== "请选择年份" &&
                                    this.state.fileStreamYear !== '') &&
                                <FileViewer fileType='pdf'
                                            filePath={this.state.fileStreamYear}
                                            onError={this.onError}
                                />
                            }
                        </div>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.combine_visible}
                    title={'立项报告'}
                    onCancel={this.hideModal.bind(this)}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal.bind(this)}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.hideModal.bind(this)}>
                            确定
                        </Button>,
                    ]}
                >
                    {
                        this.state.loadingFirst === true ?
                            <Spin tip={"加载预览中"}/>:
                            <FileViewer fileType='pdf'
                                        filePath={this.state.fileStream}
                                        onError={this.onError}
                            />
                    }

                </Modal>
        </div>
        )
    }
}

export default BuildProjectResolution;